import { useQuery } from 'react-apollo';
import {
  PreparedBuyInfoQuery as Query,
  PreparedBuyInfoQueryVariables as Variables,
} from './__generated__/PreparedBuyInfoQuery';
import * as query from './query.gql';

export const usePrice = (productId: number, qty: number) => {
  const { data, loading } = useQuery<Query, Variables>(query, {
    skip: qty <= 0,
    variables: {
      productId,
      qty,
    },
  });

  return {
    loading,
    cost: data?.stocksRemote.product?.preparedBuyInfo?.toBeReservedFromAccount,
  };
};
